import { api } from "assets/scripts/utilities/api-clients";

export const index = async (options = {}) => {
  const response = await api.get(`kam/cities/${options?.stateId}`, options);

  return response;
};

export const post = async (city) => {
  const response = await api.post("kam/cities", city);

  return response;
};

export const put = async (city) => {
  const response = await api.put("kam/cities", city);

  return response;
};
